export const executiveCommandCenterQueryKeys = {
  all: ['executive-command-center'],
  dashboard: (timeframe = 'today') => ['executive-command-center', 'dashboard', timeframe],
  recommendations: (timeframe = 'today') => ['executive-command-center', 'recommendations', timeframe],
};
